import React from 'react';
import { Button, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Navigation.css'
import logo from '../../images/logo.png'
const resumeURL = `drive.google.com/file/d/1tAIPp68onvDwA-SlOWDWU6xY_liz-2mx/view?usp=sharing`;

const Navigation = () => {
    return (
        <Navbar bg='' className='navbar-container' expand="lg">
            <Navbar.Brand className='ml-5'><img src={logo} style={{ width: '80px' }} alt="" srcset="" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto mr-5">
                    <li>
                        <Link className='single-link' to='/home'>Home</Link>
                    </li>
                    <li>
                        <Link className='single-link' to='/projects'>Projects</Link>
                    </li>
                    <li>
                        <Link className='single-link' to='/blogs'>Blogs</Link>
                    </li>
                    <li>
                        <Link className='single-link' to='/about'>About Me</Link>
                    </li>
                    <li>
                        <Link className='single-link' to='/contact'>Contact Me</Link>
                    </li>
                    <li>
                        <Link className='single-link' target='_blank' to={"//" + resumeURL}>Resume</Link>
                    </li>

                </Nav>

            </Navbar.Collapse>
        </Navbar>
    );
};

export default Navigation;